import React from 'react';
import styles from './questionChecklist.module.css';

const OptionGroup: React.FC<{
    questionId: number;
    options: any[];
    selected: number[] | undefined;
    handleOptionToggle: (questionId: number, optionId: number) => void;
    labelKey?: string;
}> = ({ questionId, options, selected, handleOptionToggle, labelKey = "Desc" }) => (
    <>
        {options.map(option => (
            <div key={option.Id} className={styles.optionItem}>
                <input
                    type="checkbox"
                    id={`option-${option.Id}`}
                    className={styles.optionCheckbox}
                    checked={selected?.includes(option.Id) || false}
                    onChange={() => handleOptionToggle(questionId, option.Id)}
                />
                <label htmlFor={`option-${option.Id}`} className={styles.optionLabel}>
                    {option[labelKey]}
                </label>
            </div>
        ))}
    </>
);

export default OptionGroup;